import * as yup from "yup";

import { IPayoutSettings } from "../../../interfaces-and-types";

export const payoutValidationSchema: yup.SchemaOf<IPayoutSettings> = yup
  .object({
    // is_instant_payout_enabled: yup.boolean().required(),
    settle_collections_to_wallet: yup.boolean().required(),
    enable_automatic_payout: yup.boolean().required(),
    automatic_payout_after_days: yup.number().required(),
  })
  .required();
